import React from 'react';
import CountUp from 'react-countup';

const Hero = () => {
    const cardStyles = "w-full lg:w-1/4 bg-white text-blue10 rounded-3xl px-5 py-6 flex flex-col items-center justify-center gap-3";
    const cardTextStyles = "text-xs font-normal pointer-events-none";
    const cardTitleStyles = "text-3xl xl:text-5xl pointer-events-none";
    return (
        <div className="container mx-auto w-full flex flex-col justify-center items-between gap-24 px-6 lg:mt-28 mt-16 py-24">
            <div className="text-black text-left flex flex-col gap-6">
                <h1 className="lg:text-5xl text-3xl font-bold pointer-events-none text-blue10">Proven Success</h1>
                <p className="lg:text-xl text-base leading-normal pointer-events-none text-grey45">With more than 30 years of combined experience in project management and digital development, PMG has helped clients across a wide range of industries bring structure to their operations and bring their projects to life. Each case study reflects what we value most: partnership, clarity, and work that delivers meaningful results.</p>
            </div>
            <div className="flex flex-col lg:flex-row justify-center font-bold container mx-auto gap-12">
                <div className={cardStyles}>
                        <CountUp
                        start={0}
                        end={30}
                        duration={1.5}
                        suffix="%"
                        enableScrollSpy={true}
                        scrollSpyOnce={true}
                        >
                            {({ countUpRef, start }) => (
                                <h3 className={cardTitleStyles} ref={countUpRef} aria-hidden="true"></h3>                                
                            )}
                        </CountUp>
                    <h4 className={cardTextStyles}>Less expensive than W-2 Employee</h4>
                </div>
                <div className={cardStyles}>
                    <CountUp
                    start={0}
                    end={2.0}
                    delay={1.0}
                    duration={1.5}
                    decimals={1}
                    decimal="."
                    prefix="$"
                    suffix="M"
                    enableScrollSpy={true}
                    scrollSpyOnce={true}
                    scrollSpyDelay={1000}
                    >
                        {({ countUpRef, start }) => (
                            <h3 className={cardTitleStyles} ref={countUpRef} aria-hidden="true"></h3>                                
                        )}
                    </CountUp>
                    <h4 className={cardTextStyles}>Managed Projects </h4>
                </div>
                <div className={cardStyles}>
                    <CountUp
                        start={0}
                        end={6000}
                        delay={1.9}
                        duration={1.0}
                        enableScrollSpy={true}
                        scrollSpyOnce={true}
                        scrollSpyDelay={1900}
                        >
                            {({ countUpRef, start }) => (
                                <h3 className={cardTitleStyles} ref={countUpRef} aria-hidden="true"></h3>                                
                            )}
                    </CountUp>
                    <h4 className={cardTextStyles}>Client hours saved</h4>
                </div>
                <div className={cardStyles}>
                    <CountUp
                        start={0}
                        end={1.2}
                        delay={3.2}
                        duration={2.0}
                        decimals={1}
                        decimal="."
                        prefix="$"
                        suffix="M+"
                        enableScrollSpy={true}
                        scrollSpyOnce={true}
                        scrollSpyDelay={3200}
                        >
                            {({ countUpRef, start }) => (
                                <h3 className={cardTitleStyles} ref={countUpRef} aria-hidden="true"></h3>                                
                            )}
                    </CountUp>
                    <h4 className={cardTextStyles}>Saved in our clients labor costs</h4>
                </div>
            </div>
        </div>
    )
}

export default Hero;
